/**
 * Centralized query key factory.
 *
 * Pola hierarchical key:
 *   keys.master.all          → invalidate semua master
 *   keys.master.branches()   → cache khusus branches
 *   keys.international.list(params) → cache per kombinasi filter/page
 *
 * Manfaat:
 *   - Tidak ada typo string key di banyak tempat
 *   - Invalidation by prefix: qc.invalidateQueries({ queryKey: keys.master.all })
 *     akan menginvalidasi semua child key di bawah master
 *   - Mudah refactor: rename satu tempat, propagate ke semua composable
 */

export const keys = {
  auth: {
    all: ["auth"],
    profile: () => [...keys.auth.all, "profile"],
  },
  master: {
    all: ["master"],
    branches: () => [...keys.master.all, "branches"],
    couriers: () => [...keys.master.all, "couriers"],
    banks: () => [...keys.master.all, "banks"],
    bankCouriers: () => [...keys.master.all, "bank-couriers"],
    payments: () => [...keys.master.all, "payments"],
    jobs: () => [...keys.master.all, "jobs"],
    roles: () => [...keys.master.all, "roles"],
    pickups: () => [...keys.master.all, "pickups"],
    costCategories: () => [...keys.master.all, "cost-categories"],
    destinations: () => [...keys.master.all, "destinations"],
    services: () => [...keys.master.all, "services"],
    agens: (params = {}) => [...keys.master.all, "agens", params],
    agenOptions: (params = {}) => [...keys.master.all, "agen-options", params],
    members: (params = {}) => [...keys.master.all, "members", params],
    pageSetting: () => [...keys.master.all, "page-setting"],
    checkOngkirProvinces: () => [
      ...keys.master.all,
      "check-ongkir",
      "provinces",
    ],
    checkOngkirCities: (province) => [
      ...keys.master.all,
      "check-ongkir",
      "cities",
      province,
    ],
  },
  users: {
    all: ["users"],
    list: (params = {}) => [...keys.users.all, "list", params],
    detail: (id) => [...keys.users.all, "detail", id],
    karyawan: (params = {}) => [...keys.users.all, "karyawan", params],
  },
  international: {
    all: ["international"],
    list: (params = {}) => [...keys.international.all, "list", params],
    listFilter: (params = {}) => [
      ...keys.international.all,
      "list-filter",
      params,
    ],
    detail: (id) => [...keys.international.all, "detail", id],
    statistic: (params = {}) => [
      ...keys.international.all,
      "statistic",
      params,
    ],
  },
  domestic: {
    all: ["domestic"],
    list: (params = {}) => [...keys.domestic.all, "list", params],
    detail: (id) => [...keys.domestic.all, "detail", id],
  },
  booking: {
    all: ["booking"],
    domestic: (params = {}) => [...keys.booking.all, "domestic", params],
    international: (params = {}) => [
      ...keys.booking.all,
      "international",
      params,
    ],
    kalogistics: (params = {}) => [...keys.booking.all, "kalogistics", params],
  },
  finance: {
    all: ["finance"],
    utangAdmin: (params = {}) => [...keys.finance.all, "utang-admin", params],
    utangMitra: (params = {}) => [...keys.finance.all, "utang-mitra", params],
    invoiceAgen: (params = {}) => [...keys.finance.all, "invoice-agen", params],
    invoiceMitra: (params = {}) => [
      ...keys.finance.all,
      "invoice-mitra",
      params,
    ],
    piutangAgen: (params = {}) => [...keys.finance.all, "piutang-agen", params],
    piutangMember: (params = {}) => [
      ...keys.finance.all,
      "piutang-member",
      params,
    ],
    biayaOperasional: (params = {}) => [
      ...keys.finance.all,
      "biaya-operasional",
      params,
    ],
    tagihanAgen: (params = {}) => [
      ...keys.finance.all,
      "tagihan-agen",
      params,
    ],
    bayarHpp: (params = {}) => [...keys.finance.all, "bayar-hpp", params],
  },
  report: {
    all: ["report"],
    finance: (params = {}) => [...keys.report.all, "finance", params],
    income: (params = {}) => [...keys.report.all, "income", params],
    incomeDomestik: (params = {}) => [
      ...keys.report.all,
      "income-domestik",
      params,
    ],
    user: (params = {}) => [...keys.report.all, "user", params],
  },
  tracking: {
    all: ["tracking"],
    byAwb: (awb) => [...keys.tracking.all, "awb", awb],
  },
  store: {
    all: ["store"],
    products: (params = {}) => [...keys.store.all, "products", params],
    orders: (params = {}) => [...keys.store.all, "orders", params],
  },
  shipping: {
    all: ["shipping"],
    costs: (params = {}) => [...keys.shipping.all, "costs", params],
    costDetail: (id) => [...keys.shipping.all, "cost-detail", id],
  },
};

export default keys;
